export async function createDebugModules(app) {
  const Stats = (await import('./Stats')).Stats;
  const stats = new Stats(app);
  await stats.load();

  return {
    // pane,
    stats,
  };
}
